/**
 * Media queries the workspace layout reads from JavaScript.
 *
 * They use rem, the same unit as the `--breakpoint-cols2` and
 * `--breakpoint-cols3` tokens in `src/styles/index.css`, so CSS and JavaScript
 * agree even when the user changes the browser font size. KEEP THE TWO FILES IN
 * SYNC: 47.5rem is 760px and 80rem is 1280px at the default font size.
 */
export const MEDIA = {
    twoColumns: '(min-width: 47.5rem)',
    threeColumns: '(min-width: 80rem)',
    /**
     * The Developer portal's master/detail split: the client list sits beside
     * the client page from 1100px (68.75rem), and is one screen at a time
     * below. Read only from JavaScript, so there is no CSS token for it.
     */
    developerSplit: '(min-width: 68.75rem)',
    /**
     * From 400px (25rem) the signed-in header shows the full logo; below, its
     * wave mark alone, so the logo, the section picker and the avatar fit one
     * row at 360px (UI-12b). JavaScript only: it picks an SVG viewBox.
     */
    fullLogo: '(min-width: 25rem)',
} as const;
